import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/core";

export interface SignUpButtonProps {
  to?: string;
  className?: string;
}

/** "Regístrate" de la barra superior: la acción primaria del cromo. */
export function SignUpButton({ to = "/register", className }: SignUpButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      as={Link}
      to={to}
      variant="primary"
      size="sm"
      leftIcon={<UserPlus />}
      className={className}
    >
      {t("Regístrate")}
    </Button>
  );
}
